import { Injectable, inject } from '@angular/core';
import * as ExcelJS from 'exceljs';
import { SysUtilService } from './sysUtil.service';
import { env } from '../../../app.constant';


@Injectable()
export class SABAUDBReportUtilSTFService {

    private sysUtil: SysUtilService = inject(SysUtilService);

    private initialPosition = 12;

    // private numberFormat = "#,##0.00";
    private numberFormat = "#,##0.00_);[Red](#,##0.00)";

    private fontStyle = {
        header: { name: 'Times New Roman', size: 10, bold: true },
        content: { name: 'Times New Roman', size: 10 }
    };
    private columns = [
        'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J',
        'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T',
        'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'AB', 'AC', 'AD',
        'AE', 'AF', 'AG', 'AH', 'AI', 'AJ', 'AK', 'AL', 'AM', 'AN',
        'AO', 'AP', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AV', 'AW', 'AX',
        'AY', 'AZ', 'BA', 'BB', 'BC', 'BD', 'BE', 'BF', 'BG', 'BH',
        'BI', 'BJ'
    ];
    private columnTitle = [
        'Savings from & Prior Years', 'Continuing Investment', 'SB',
        'Savings from & Prior Years', 'Continuing Investment', 'SB',
        'Savings from & Prior Years', 'Continuing Investment', 'SB',
        'Savings from & Prior Years', 'Continuing Investment', 'SB',
        'Savings from & Prior Years', 'Continuing Investment', 'SB',
        'Savings from & Prior Years', 'Continuing Investment', 'SB',
        'Savings from & Prior Years', 'Continuing Investment', 'SB',
        'Savings from & Prior Years', 'Continuing Investment', 'SB',
        'Savings from & Prior Years', 'Continuing Investment', 'SB',
        'Savings from & Prior Years', 'Continuing Investment', 'SB',
        'Savings from & Prior Years', 'Continuing Investment', 'SB',
        'Savings from & Prior Years', 'Continuing Investment', 'SB'
    ];
    private borderStyle: any = {
        thin: { style: 'thin' },
        full: {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        },
        topBottom: {
            top: { style: 'thin' },
            bottom: { style: 'thin' }
        },
        leftRight: {
            left: { style: 'thin' },
            right: { style: 'thin' }
        },
        topLeft: {
            top: { style: 'thin' },
            left: { style: 'thin' }
        },
        topRight: {
            top: { style: 'thin' },
            left: { style: 'thin' }
        },
        bottomLeft: {
            bottom: { style: 'thin' },
            left: { style: 'thin' }
        },
        bottomRight: {
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        }
    };

    private formula: any = {
        f: `IF(OR(NOT(D*=""),NOT(E*="")),IF(D*="",0,D*)+IF(E*="",0,E*),"")`,
        g: `IF(OR(NOT(C*=""),NOT(D*=""),NOT(E*="")),IF(C*="",0,C*)+IF(D*="",0,D*)+IF(E*="",0,E*),"")`,
        k: `IF(OR(NOT(I*=""),NOT(J*="")),IF(I*="",0,I*)+IF(J*="",0,J*),"")`,
        l: `IF(OR(NOT(H*=""),NOT(I*=""),NOT(J*="")),IF(H*="",0,H*)+IF(I*="",0,I*)+IF(J*="",0,J*),"")`,
        p: `IF(OR(NOT(N*=""),NOT(O*="")),IF(N*="",0,N*)+IF(O*="",0,O*),"")`,
        q: `IF(OR(NOT(M*=""),NOT(N*=""),NOT(O*="")),IF(M*="",0,M*)+IF(N*="",0,N*)+IF(O*="",0,O*),"")`,
        u: `IF(OR(NOT(S*=""),NOT(T*="")),IF(S*="",0,S*)+IF(T*="",0,T*),"")`,
        v: `IF(OR(NOT(R*=""),NOT(S*=""),NOT(T*="")),IF(R*="",0,R*)+IF(S*="",0,S*)+IF(T*="",0,T*),"")`,
        z: `IF(OR(NOT(X*=""),NOT(Y*="")),IF(X*="",0,X*)+IF(Y*="",0,Y*),"")`,
        aa: `IF(OR(NOT(W*=""),NOT(X*=""),NOT(Y*="")),IF(W*="",0,W*)+IF(X*="",0,X*)+IF(Y*="",0,Y*),"")`,
        ae: `IF(OR(NOT(AC*=""),NOT(AD*="")),IF(AC*="",0,AC*)+IF(AD*="",0,AD*),"")`,
        af: `IF(OR(NOT(AB*=""),NOT(AC*=""),NOT(AD*="")),IF(AB*="",0,AB*)+IF(AC*="",0,AC*)+IF(AD*="",0,AD*),"")`,
        aj: `IF(OR(NOT(AH*=""),NOT(AI*="")),IF(AH*="",0,AH*)+IF(AI*="",0,AI*),"")`,
        ak: `IF(OR(NOT(AG*=""),NOT(AH*=""),NOT(AI*="")),IF(AG*="",0,AG*)+IF(AH*="",0,AH*)+IF(AI*="",0,AI*),"")`,
        ao: `IF(OR(NOT(AM*=""),NOT(AN*="")),IF(AM*="",0,AM*)+IF(AN*="",0,AN*),"")`,
        ap: `IF(OR(NOT(AL*=""),NOT(AM*=""),NOT(AN*="")),IF(AL*="",0,AL*)+IF(AM*="",0,AM*)+IF(AN*="",0,AN*),"")`,
        at: `IF(OR(NOT(AR*=""),NOT(AS*="")),IF(AR*="",0,AR*)+IF(AS*="",0,AS*),"")`,
        au: `IF(OR(NOT(AQ*=""),NOT(AR*=""),NOT(AS*="")),IF(AQ*="",0,AQ*)+IF(AR*="",0,AR*)+IF(AS*="",0,AS*),"")`,
        ay: `IF(OR(NOT(AW*=""),NOT(AX*="")),IF(AW*="",0,AW*)+IF(AX*="",0,AX*),"")`,
        az: `IF(OR(NOT(AV*=""),NOT(AW*=""),NOT(AX*="")),IF(AV*="",0,AV*)+IF(AW*="",0,AW*)+IF(AX*="",0,AX*),"")`,
        bd: `IF(OR(NOT(BB*=""),NOT(BC*="")),IF(BB*="",0,BB*)+IF(BC*="",0,BC*),"")`,
        be: `IF(OR(NOT(BA*=""),NOT(BB*=""),NOT(BC*="")),IF(BA*="",0,BA*)+IF(BB*="",0,BB*)+IF(BC*="",0,BC*),"")`,
        bi: `IF(OR(NOT(BG*=""),NOT(BH*="")),IF(BG*="",0,BG*)+IF(BH*="",0,BH*),"")`,
        bj: `IF(OR(NOT(BF*=""),NOT(BG*=""),NOT(BH*="")),IF(BF*="",0,BF*)+IF(BG*="",0,BG*)+IF(BH*="",0,BH*),"")`
    };

    async generateExcel(content: Array<any>, campus: number, year: number, options: any = { fileName: "SABAUDB", sheetName: "Sheet1" }) {

        this.columnTitle[0] = `Savings from ${year - 1} & Prior Years`;
        this.columnTitle[3] = `Savings from ${year - 1} & Prior Years`;
        this.columnTitle[6] = `Savings from ${year - 1} & Prior Years`;
        this.columnTitle[9] = `Savings from ${year - 1} & Prior Years`;
        this.columnTitle[12] = `Savings from ${year - 1} & Prior Years`;
        this.columnTitle[15] = `Savings from ${year - 1} & Prior Years`;
        this.columnTitle[18] = `Savings from ${year - 1} & Prior Years`;
        this.columnTitle[21] = `Savings from ${year - 1} & Prior Years`;
        this.columnTitle[24] = `Savings from ${year - 1} & Prior Years`;
        this.columnTitle[27] = `Savings from ${year - 1} & Prior Years`;
        this.columnTitle[30] = `Savings from ${year - 1} & Prior Years`;
        this.columnTitle[33] = `Savings from ${year - 1} & Prior Years`;

        let data = [];

        content.forEach((d: any) => {
            let dt = JSON.parse(JSON.stringify(d));
            dt.fnd_name = d.fnd_name.replaceAll(/(<([^>]+)>)|(\&nbsp;)/ig, '');
            data.push(dt);
        });

        const wb = new ExcelJS.Workbook();
        const ws = wb.addWorksheet(options.sheetName);
        // const ws = wb.getWorksheet(options.sheetName);

        const imagePath = './assets/BatStateULogo.png';

        this.sysUtil.getBase64ImageFromUrl(imagePath).then(async (result: any) => {
            let imageId = wb.addImage({
                base64: result,
                extension: 'png'
            });
            ws.addImage(imageId, {
                tl: { col: 7, row: 0 },
                ext: { width: 120, height: 110 }
            });

            ws.columns = [
                { header: "", key: "fnd_name", width: 46 },
                { header: "", key: "acct_uacs_code", width: 15 },

                { header: "", key: "appr_amount_pre", width: 16 },
                { header: "", key: "appr_amount_sb", width: 16 },
                { header: "", key: "appr_amount_cb", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },

                { header: "", key: "adjustment_amount_pre", width: 16 },
                { header: "", key: "adjustment_amount_sb", width: 16 },
                { header: "", key: "adjustment_amount_cb", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },

                { header: "", key: "adjusted_amount_pre", width: 16 },
                { header: "", key: "adjusted_amount_sb", width: 16 },
                { header: "", key: "adjusted_amount_cb", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },

                { header: "", key: "total_allotment_pre", width: 16 },
                { header: "", key: "total_allotment_sb", width: 16 },
                { header: "", key: "total_allotment_cb", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },

                { header: "", key: "re_total_pre", width: 16 },
                { header: "", key: "re_total_sb", width: 16 },
                { header: "", key: "re_total_cb", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },

                { header: "", key: "total_adj_pre", width: 16 },
                { header: "", key: "total_adj_sb", width: 16 },
                { header: "", key: "total_adj_cb", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },

                { header: "", key: "ors_total_pre", width: 16 },
                { header: "", key: "ors_total_sb", width: 16 },
                { header: "", key: "ors_total_cb", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },

                { header: "", key: "dis_total_pre", width: 16 },
                { header: "", key: "dis_total_sb", width: 16 },
                { header: "", key: "dis_total_cb", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },

                { header: "", key: "ors_unobligated_allotment_pre", width: 16 },
                { header: "", key: "ors_unobligated_allotment_sb", width: 16 },
                { header: "", key: "ors_unobligated_allotment_cb", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },

                { header: "", key: "due_demandable_pre", width: 16 },
                { header: "", key: "due_demandable_sb", width: 16 },
                { header: "", key: "due_demandable_cb", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },

                { header: "", key: "due_demandable_pre", width: 16 },
                { header: "", key: "due_demandable_sb", width: 16 },
                { header: "", key: "due_demandable_cb", width: 16 },
                { header: "", key: "", width: 16 },
                { header: "", key: "", width: 16 },
            ];

            console.log(`total_content`, data);

            this.setHeader(ws, Number(campus), Number(year));

            let position = this.initialPosition + 6;
            data.forEach((data: any, i: number) => {

                data.due_demandable = (Number(data.due_demandable) == 0) ? "" : Number(data.due_demandable);
                data.not_yet_due = (Number(data.not_yet_due) == 0) ? "" : Number(data.not_yet_due);

                const exempted = ['fnd_name', 'acct_uacs_code', 'due_demandable', 'not_yet_due'];
                Object.keys(data).forEach((key: string) => {
                    if (!exempted.includes(key)) {
                        data[key] = (Number(data[key]) == 0) ? "" : Number(data[key]);
                    }
                });

                ws.addRow(data);

                this.columns.forEach((col: string, index: number) => {
                    let cell = ws.getCell(`${col}${position + i}`);
                    if (index >= 2) {
                        // cell.getCell(`J${currentRow}`).value = { formula: `sum(J${rowPosition}:J${currentRow - 1})+sum(${this.particularsTotalAmountValue.join(",")})`, date1904: false };
                        if (Object.keys(this.formula).includes(col.toLowerCase())) {
                            cell.value = { formula: `${this.formula[col.toLowerCase()].replaceAll('*', (position + i))}`, date1904: false };
                        }
                        cell.style = { numFmt: this.numberFormat };
                    }
                    cell.font = (data.aa_fnd_sysref_code == '') ? this.fontStyle.header : this.fontStyle.content;
                    cell.border = this.borderStyle.full;
                    cell.alignment = { wrapText: true, vertical: 'middle', horizontal: (col == 'A') ? 'left' : 'right' };
                });
            });

            const arrayData = await wb.xlsx.writeBuffer();
            const blob = new Blob([arrayData], { type: "application/octet-binary" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${options.fileName}.xlsx`;
            a.click();
            a.remove();
        });
    }

    private setHeader(ws: ExcelJS.Worksheet, campus: number, year: number) {
        let position = this.initialPosition + 1;

        // header title
        ws.mergeCells(`A1:AA1`);
        let row1 = ws.getCell(`A1`);
        row1.value = "Republic of the Philippines";
        row1.font = this.fontStyle.content;
        row1.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`A2:AA2`);
        let row2 = ws.getCell(`A2`);
        row2.value = "BATANGAS STATE UNIVERSITY";
        row2.font = this.fontStyle.header;
        row2.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`A3:AA3`);
        let row3 = ws.getCell(`A3`);
        row3.value = "The National Engineering University";
        row3.font = this.fontStyle.header;
        row3.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        let campusData = env.campuses.find((c: any) => c.value == campus);
        ws.mergeCells(`A4:AA4`);
        let row4 = ws.getCell(`A4`);
        row4.value = `${campusData.details.name}`;
        row4.font = this.fontStyle.header;
        row4.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`A5:AA5`);
        let row5 = ws.getCell(`A5`);
        row5.value = `${campusData.details.addr}`;
        row5.font = this.fontStyle.content;
        row5.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`A6:AA6`);
        let row6 = ws.getCell(`A6`);
        row6.value = `Tel Nos.: ${campusData.details.contact}`;
        row6.font = this.fontStyle.content;
        row6.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`A7:AA7`);
        let row7 = ws.getCell(`A7`);
        row7.value = `E-mail Address: ${campusData.details.email} | Website Address: https://batstate-u.edu.ph`;
        row7.font = this.fontStyle.content;
        row7.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`A9:AA9`);
        let row9 = ws.getCell(`A9`);
        row9.value = "Summary of Approved Budget, Allotment, Utilizations & Balances (SABAUD)";
        row9.font = this.fontStyle.header;
        row9.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`A10:AA10`);
        let row10 = ws.getCell(`A10`);
        row10.value = `Special Trust Fund (STF) FY ${year}`;
        row10.font = this.fontStyle.header;
        row10.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`A11:AA11`);
        let row11 = ws.getCell(`A11`);
        row11.value = `as of ${year}`;
        row11.font = this.fontStyle.header;
        row11.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        // header body
        let ctRow = ws.getRow(position + 1);
        ctRow.height = 56;

        ws.mergeCells(`A${position}:A${position + 4}`);
        let particulars = ws.getCell(`A${position + 4}`);
        particulars.value = "Particulars";
        particulars.font = this.fontStyle.header;
        particulars.border = this.borderStyle.full;
        particulars.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`B${position}:B${position + 4}`);
        let uacs_code = ws.getCell(`B${position + 4}`);
        uacs_code.value = "UACS Code";
        uacs_code.font = this.fontStyle.header;
        uacs_code.border = this.borderStyle.full;
        uacs_code.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`C${position}:Q${position}`);
        let budgetHeader = ws.getCell(`C${position}`);
        budgetHeader.value = `Approved Budget FY ${year}`;
        budgetHeader.font = this.fontStyle.header;
        budgetHeader.border = this.borderStyle.full;
        budgetHeader.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`R${position}:AF${position}`);
        let allotmentHeader = ws.getCell(`R${position}`);
        allotmentHeader.value = "Allotment";
        allotmentHeader.font = this.fontStyle.header;
        allotmentHeader.border = this.borderStyle.full;
        allotmentHeader.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`AG${position}:AJ${position + 2}`);
        let utilizationHeader = ws.getCell(`AG${position}`);
        utilizationHeader.value = "Utilization";
        utilizationHeader.font = this.fontStyle.header;
        utilizationHeader.border = this.borderStyle.full;
        utilizationHeader.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`AL${position}:AP${position + 2}`);
        let disbursementHeader = ws.getCell(`AL${position}`);
        disbursementHeader.value = "Disbursement";
        disbursementHeader.font = this.fontStyle.header;
        disbursementHeader.border = this.borderStyle.full;
        disbursementHeader.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`AQ${position}:BJ${position}`);
        let balancesHeader = ws.getCell(`AQ${position}`);
        balancesHeader.value = "Balances";
        balancesHeader.font = this.fontStyle.header;
        balancesHeader.border = this.borderStyle.full;
        balancesHeader.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`C${position + 1}:G${position + 2}`);
        let approvedBudget = ws.getCell(`C${position + 1}`);
        approvedBudget.value = `Approved Budget FY ${year}`;
        approvedBudget.font = this.fontStyle.header;
        approvedBudget.border = this.borderStyle.full;
        approvedBudget.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`H${position + 1}:L${position + 2}`);
        let adjustment = ws.getCell(`H${position + 1}`);
        adjustment.value = "Adjustment";
        adjustment.font = this.fontStyle.header;
        adjustment.border = this.borderStyle.full;
        adjustment.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`M${position + 1}:Q${position + 2}`);
        let adjustedApproved = ws.getCell(`M${position + 1}`);
        adjustedApproved.value = "Adjusted Approved Budget";
        adjustedApproved.font = this.fontStyle.header;
        adjustedApproved.border = this.borderStyle.full;
        adjustedApproved.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`R${position + 1}:V${position + 2}`);
        let allotmentReceived = ws.getCell(`R${position + 1}`);
        allotmentReceived.value = "Allotment Received";
        allotmentReceived.font = this.fontStyle.header;
        allotmentReceived.border = this.borderStyle.full;
        allotmentReceived.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`W${position + 1}:AA${position + 2}`);
        let adjustments = ws.getCell(`W${position + 1}`);
        adjustments.value = "Adjustments (Reduction, Modification)";
        adjustments.font = this.fontStyle.header;
        adjustments.border = this.borderStyle.full;
        adjustments.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`AB${position + 1}:AF${position + 2}`);
        let adjustedTotal = ws.getCell(`AB${position + 1}`);
        adjustedTotal.value = "Adjusted Total Allotment";
        adjustedTotal.font = this.fontStyle.header;
        adjustedTotal.border = this.borderStyle.full;
        adjustedTotal.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`AQ${position + 1}:AU${position + 2}`);
        let unobligated = ws.getCell(`AQ${position + 1}`);
        unobligated.value = "Unobligated Allotment";
        unobligated.font = this.fontStyle.header;
        unobligated.border = this.borderStyle.full;
        unobligated.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`AV${position + 1}:BJ${position + 1}`);
        let unpaid = ws.getCell(`AV${position + 1}`);
        unpaid.value = "Unpaid";
        unpaid.font = this.fontStyle.header;
        unpaid.border = this.borderStyle.full;
        unpaid.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`AV${position + 2}:AZ${position + 2}`);
        let dueDemandable1 = ws.getCell(`AV${position + 2}`);
        dueDemandable1.value = "Due & Demandable";
        dueDemandable1.font = this.fontStyle.header;
        dueDemandable1.border = this.borderStyle.full;
        dueDemandable1.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`BA${position + 2}:BE${position + 2}`);
        let dueDemandable2 = ws.getCell(`BA${position + 2}`);
        dueDemandable2.value = "Due & Demandable";
        dueDemandable2.font = this.fontStyle.header;
        dueDemandable2.border = this.borderStyle.full;
        dueDemandable2.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`BF${position + 2}:BJ${position + 2}`);
        let unreleasedApprovedBudget = ws.getCell(`BF${position + 2}`);
        unreleasedApprovedBudget.value = "Unreleased Approved Budget";
        unreleasedApprovedBudget.font = this.fontStyle.header;
        unreleasedApprovedBudget.border = this.borderStyle.full;
        unreleasedApprovedBudget.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        const preColumns = ['C', 'H', 'M', 'R', 'W', 'AB', 'AG', 'AL', 'AQ', 'AV', 'BA', 'BF'];
        preColumns.forEach(col => {
            ws.mergeCells(`${col}${position + 3}:${col}${position + 4}`);
            let preCell = ws.getCell(`${col}${position + 3}`);
            preCell.value = "PRE";
            preCell.font = this.fontStyle.header;
            preCell.border = this.borderStyle.full;
            preCell.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };
        });

        const supplementalColumns = [
            { start: 'D', end: 'F' },
            { start: 'I', end: 'K' },
            { start: 'N', end: 'P' },
            { start: 'S', end: 'U' },
            { start: 'X', end: 'Z' },
            { start: 'AC', end: 'AE' },
            { start: 'AH', end: 'AJ' },
            { start: 'AM', end: 'AO' },
            { start: 'AR', end: 'AT' },
            { start: 'AW', end: 'AY' },
            { start: 'BB', end: 'BD' },
            { start: 'BG', end: 'BI' }
        ];
        supplementalColumns.forEach(col => {
            ws.mergeCells(`${col.start}${position + 3}:${col.end}${position + 3}`);
            let supplementalCell = ws.getCell(`${col.start}${position + 3}`);
            supplementalCell.value = "Supplemental Budget";
            supplementalCell.font = this.fontStyle.header;
            supplementalCell.border = this.borderStyle.full;
            supplementalCell.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };
        });

        const stfColumns = ['G', 'L', 'Q', 'V', 'AA', 'AF', 'AK', 'AP', 'AU', 'AZ', 'BE', 'BJ'];
        stfColumns.forEach(col => {
            ws.mergeCells(`${col}${position + 3}:${col}${position + 4}`);
            let stfCell = ws.getCell(`${col}${position + 3}`);
            stfCell.value = "STF";
            stfCell.font = this.fontStyle.header;
            stfCell.border = this.borderStyle.full;
            stfCell.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };
        });

        const colExceptions = [
            'A', 'B', 'C', 'G', 'L', 'Q', 'V', 'H', 'M', 'R', 'W', 'AB', 'AG', 'AL', 'AQ', 'AV', 'BA', 'BF', 'AA', 'AF', 'AK', 'AP', 'AU', 'AZ', 'BE', 'BJ'
        ];
        const columnsToProcess = this.columns.filter((l: string) => !colExceptions.includes(l));
        columnsToProcess.forEach((t: string, i: number) => {
            const cell = ws.getCell(`${t}${position + 4}`);
            cell.value = this.columnTitle[i];
            cell.font = this.fontStyle.header;
            cell.border = this.borderStyle.full;
            cell.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };
        });
    }

}
